import { Card } from 'react-bootstrap';

function CustomPromptsDescription() {
  return (
    <Card style={{ border: 0 }}>
      <Card.Body>
        <Card.Header>Audio Requirements</Card.Header>
        <ul>
          <li>16-bit PCM</li>
          <li>Monophonic Audio</li>
          <li>16kHz</li>
          <li>WAV file format</li>
        </ul>
      </Card.Body>
    </Card>
  );
}

export default CustomPromptsDescription;
